import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { formatNumber } from '@app/helpers/webform';
import { KeyValue } from '@app/services/webform.service';
import { add, format, parse, endOfMonth } from 'date-fns';

@Component({
  standalone: false,
  selector: 'webform-calc-cyber',
  templateUrl: './cyber.component.html',
  styleUrls: ['./cyber.component.scss'],
})
export class CyberComponent implements OnInit {
  @Input() result!: KeyValue;
  @Input() formId!: string;
  @Input() formData!: KeyValue;
  formatNumber: Function = formatNumber;

  readonly #cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    setTimeout(() => {
      this.#cdr.detectChanges();
    }, 300);
  }

  get today(): string {
    return format(new Date(), 'dd.MM.yyyy');
  }
  get contractStart(): string {
    const date = this.formData[`${this.formId}--ins_start_date`];
    if (date) return date;
    return '';
  }

  public get contractEnd(): string {
    let start: any =
      this.formData[`${this.formId}--ins_start`] === 'today'
        ? this.today
        : this.contractStart;
    if (!start) return '';
    start = parse(start, 'dd.MM.yyyy', new Date());

    // Add 10 years to the start date
    const endDate = add(start, { years: 10 });

    // Get the last day of the month for the end date
    const lastDayOfMonth = endOfMonth(endDate);

    // Format the last day of the month in 'dd.MM.yyyy' format
    return format(lastDayOfMonth, 'dd.MM.yyyy');
  }
}
